export const QUAL_STEPS = [
  {
    key: 'monthlyIncome',
    fr: 'Quel est votre revenu mensuel brut?',
    en: 'What is your gross monthly income?',
    options: [
      ['Moins de 2 000 $', 'Less than $2,000'],
      ['2 000 $ - 3 000 $', '$2,000 - $3,000'],
      ['3 000 $ - 4 000 $', '$3,000 - $4,000'],
      ['4 000 $ et plus', '$4,000+'],
    ],
  },
  {
    key: 'employmentType',
    fr: 'Quel est votre type d’emploi?',
    en: 'What type of employment do you have?',
    options: [
      ['Temps plein', 'Full-time'],
      ['Temps partiel', 'Part-time'],
      ['Travailleur autonome', 'Self-employed'],
      ['Retraité', 'Retired'],
      ['Autre revenu (prestations, pension)', 'Other income (benefits, pension)'],
    ],
  },
  {
    key: 'jobTenure',
    fr: 'Depuis combien de temps à cet emploi?',
    en: 'How long at your current job?',
    options: [
      ['Moins de 3 mois', 'Less than 3 months'],
      ['3 à 12 mois', '3 to 12 months'],
      ['1 an et plus', '1 year or more'],
    ],
  },
  {
    key: 'creditSituation',
    fr: 'Comment décririez-vous votre crédit?',
    en: 'How would you describe your credit?',
    options: [
      ['Bon', 'Good'],
      ['Moyen', 'Fair'],
      ['Faillite', 'Bankruptcy'],
      ['Proposition de consommateur', 'Consumer proposal'],
      ['Aucun crédit', 'No credit'],
    ],
  },
  {
    key: 'downPayment',
    fr: 'Avez-vous une mise de fonds ou un échange?',
    en: 'Do you have a down payment or trade-in?',
    options: [
      ['Aucune', 'None'],
      ['Mise de fonds comptant', 'Cash down payment'],
      ['Véhicule en échange', 'Vehicle to trade in'],
    ],
  },
];
